import { css } from '@emotion/react';
import t from 'react-translate';
import ProgramReflections from './program-reflections';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';

const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;
`;

const ProgramWrapUp = () => {
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_WRAP_UP;

  return (
    <div css={styles} className='mx-auto mb-8'>
      <div className='title heading-2 mb-2'>
        {translationBase.TITLE()}
      </div>
      <div className='description text-regular mb-6'>
        {translationBase.DESCRIPTION()}
      </div>
      <ProgramReflections />
    </div>
  );
};

export default ProgramWrapUp;
